import React from "react";
// import { getPropertyNoCase } from "../../utils/generic";

export default function RenderInlineForm({ data, identifier }) {
  return (
    <>
      <div key={identifier} className="row col-xs-12 center-xs">
        {(data || []).map((item, index) => (
          <div className="col-xs" key={"CirticalEng" + index}>
            <div className="value-count">
              {/* {getFormattedString(
                getPropertyNoCase(item, "attributeValue"),
                getPropertyNoCase(item, "DataFormat")
              )} */}
            </div>
            <div className="value-title">
              {/* {getPropertyNoCase(item, "attributeName")} */}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
